// extracted by mini-css-extract-plugin
export default {"button":"Xi-z","reviewSort":"Yi-z"};